import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { RADIO_DEFAULT_CHECKED, RADIO_DEFAULT_DISABLED, RADIO_DEFAULT_MODE, RADIO_DEFAULT_ROLE, RADIO_DEFAULT_SIZE } from './Radio.constants';
import { RadioHidden, RadioLabel, RadioVisible, RadioWrapper } from './Radio.styled';
// Component.
// -----------------------------------------------------------------------------
const Radio = forwardRef(({ checked = RADIO_DEFAULT_CHECKED, disabled = RADIO_DEFAULT_DISABLED, id, label, name, mode = RADIO_DEFAULT_MODE, onChange, role = RADIO_DEFAULT_ROLE, size = RADIO_DEFAULT_SIZE, value, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsxs(RadioWrapper, { children: [_jsx(RadioHidden, { checked: checked, disabled: disabled, id: id || name, name: name, ref: ref, onChange: onChange, value: value, ...rest }), _jsxs(RadioLabel, { htmlFor: id || name, scale: size, children: [_jsx(RadioVisible, { ...(role && { className: role }), checked: checked, disabled: disabled, mode: mode }), label] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Radio.displayName = 'Radio';
export default Radio;
//# sourceMappingURL=Radio.js.map